<template>
  <div class="flex flex-col flex-1 gap-1 justify-around">
    <div
      class="mb-1 font-medium flex-wrap flex items-baseline gap-x-2 gap-y-1 justify-start max-w-[90%]"
    >
      {{ title }}
      <slot name="title"></slot>
    </div>

    <div class="text-sm font-normal">
      {{ description }}

      <p v-if="$slots.details">
        <slot name="details"></slot>
      </p>

      <div v-if="disabled" class="w-full inline-flex items-center mt-1">
        <h3
          class="flex-auto bg-pink-700 font-medium text-center text-white text-sm -mx-4 py-2 tracking-widest"
        >
          PRÓXIMAMENTE
        </h3>
      </div>
    </div>

    <div class="flex justify-between items-center">
      <div class="text-base font-medium">{{ !isPriceHidden ? price : " " }}</div>
      <img
        class="md:w-[61px] md:h-[61px] rounded-full"
        :class="{
          'mix-blend-luminosity': disabled === true,
        }"
        :src="imageSrc"
        width="41"
        height="41"
      />
    </div>
  </div>
</template>

<script>
export default {
  inject: ["isPriceHidden"],
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    price: {
      type: String,
    },
    imageSrc: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getImageUrl() {
      // This path must be correct for your file
      return new URL(`/app/assets/images/${this.imageSrc}`, import.meta.url);
    },
  },
};
</script>
